import { TimeService } from 'src/app/services/time.service';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OdometerReading } from 'src/app/entities/OdometerReading';
import * as dayjs from 'dayjs';
import { ActivityLog } from 'src/app/entities/ActivityLog';
import { ActionValidationException } from 'src/app/utils/exceptions';
import { NotificationsService } from 'src/app/services/notifications.service';
import { OdometerReadingModalComponent } from '../odometer-reading-modal/odometer-reading-modal.component';
import { Project } from 'src/app/entities/Project';

export interface MileageLogCardData {
  odometerReading: OdometerReading;
  activityLog: ActivityLog;
  project: Project;
  date: dayjs.Dayjs;
  highlighted?: boolean;
  allowClosure?: boolean;
}

@Component({
  selector: 'app-mileage-log-card',
  templateUrl: './mileage-log-card.component.html',
  styleUrls: ['./mileage-log-card.component.scss'],
})
export class MileageLogCardComponent implements OnInit {
  @Input() cardData: MileageLogCardData;
  @Input() projects: Project[];
  @Input() canEdit: boolean = false;

  constructor(private timeService: TimeService, private modalController: ModalController, private notificationsService: NotificationsService) {}

  ngOnInit() {}

  onCardClick() {
    if (this.canEdit) {
      this.openOdometerReadingModal();
    }
  }

  async openOdometerReadingModal() {
    try {
      await this.timeService.validateTimeModification(this.cardData.activityLog.UserId, this.cardData.activityLog.ActivityDate);
      const modal = await this.modalController.create({
        component: OdometerReadingModalComponent,
        cssClass: 'mileage-modal',
        componentProps: {
          odometerReading: this.cardData.odometerReading,
          odometerReadingProject: this.cardData.project,
          projects: this.projects,
          date: this.cardData.date,
          allowClosure: this.cardData.allowClosure,
        },
      });
      await modal.present();
    } catch (error) {
      if (error instanceof ActionValidationException) {
        this.notificationsService.showAlert({
          header: 'Warning',
          message: 'The date you are modifying has already been verified. Your supervisor will need to return your activity log to you before edits can be made.',
          buttons: ['OK'],
        });
      }
    }
  }
}
